var X, ee;
function De() {
  if (ee) return X;
  ee = 1;
  var e = Object.defineProperty, i = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, a = Object.prototype.hasOwnProperty, o = (n, t) => {
    for (var l in t)
      e(n, l, { get: t[l], enumerable: !0 });
  }, r = (n, t, l, u) => {
    if (t && typeof t == "object" || typeof t == "function")
      for (let f of s(t))
        !a.call(n, f) && f !== l && e(n, f, { get: () => t[f], enumerable: !(u = i(t, f)) || u.enumerable });
    return n;
  }, c = (n) => r(e({}, "__esModule", { value: !0 }), n), h = {};
  o(h, {
    XmlCdata: () => F,
    XmlComment: () => R,
    XmlDeclaration: () => V,
    XmlDocument: () => G,
    XmlDocumentType: () => H,
    XmlElement: () => _,
    XmlError: () => K,
    XmlNode: () => m,
    XmlProcessingInstruction: () => D,
    XmlText: () => C,
    parseXml: () => _e
  }), X = c(h);
  var p = "", g = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, T = class {
    constructor(n) {
      if (this.k = this.u(n, !0), this.d = 0, this.length = n.length, this.l = this.k !== this.length, this.h = n, this.l) {
        let t = [];
        for (let l = 0, u = 0; u < this.k; ++u)
          t[u] = l, l += n.codePointAt(l) > 65535 ? 2 : 1;
        this.A = t;
      }
    }
    /**
     * Whether the current character index is at the end of the input string.
     */
    get B() {
      return this.d >= this.k;
    }
    // -- Protected Methods ------------------------------------------------------
    /**
     * Returns the number of characters in the given string, which may differ from
     * the byte length if the string contains multibyte characters.
     */
    u(n, t = this.l) {
      return t ? n.replace(g, "_").length : n.length;
    }
    // -- Public Methods ---------------------------------------------------------
    /**
     * Advances the scanner by the given number of characters, stopping if the end
     * of the string is reached.
     */
    p(n = 1) {
      this.d = Math.min(this.k, this.d + n);
    }
    /**
     * Returns the byte index of the given character index in the string. The two
     * may differ in strings that contain multibyte characters.
     */
    f(n = this.d) {
      var t;
      return this.l ? (t = this.A[n]) != null ? t : 1 / 0 : n;
    }
    /**
     * Consumes and returns the given number of characters if possible, advancing
     * the scanner and stopping if the end of the string is reached.
     *
     * If no characters could be consumed, an empty string will be returned.
     */
    G(n = 1) {
      let t = this.m(n);
      return this.p(n), t;
    }
    /**
     * Consumes and returns the given number of bytes if possible, advancing the
     * scanner and stopping if the end of the string is reached.
     *
     * It's up to the caller to ensure that the given byte count doesn't split a
     * multibyte character.
     *
     * If no bytes could be consumed, an empty string will be returned.
     */
    v(n) {
      let t = this.f(), l = this.h.slice(t, t + n);
      return this.p(this.u(l)), l;
    }
    /**
     * Consumes and returns all characters for which the given function returns
     * `true`, stopping when `false` is returned or the end of the input is
     * reached.
     */
    w(n) {
      let { length: t, l, h: u } = this, f = this.f(), d = f;
      if (l)
        for (; d < t; ) {
          let b = u[d], v = b >= "\uD800" && b <= "\uDBFF";
          if (v && (b += u[d + 1]), !n(b))
            break;
          d += v ? 2 : 1;
        }
      else
        for (; d < t && n(u[d]); )
          ++d;
      return this.v(d - f);
    }
    /**
     * Consumes the given string if it exists at the current character index, and
     * advances the scanner.
     *
     * If the given string doesn't exist at the current character index, an empty
     * string will be returned and the scanner will not be advanced.
     */
    b(n) {
      let { length: t } = n, l = this.f();
      return n === this.h.slice(l, l + t) ? (this.p(t === 1 ? 1 : this.u(n)), n) : p;
    }
    /**
     * Consumes characters until the given global regex is matched, advancing the
     * scanner up to (but not beyond) the beginning of the match. If the regex
     * doesn't match, nothing will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    x(n) {
      let t = this.h.slice(this.f()).search(n);
      return t > 0 ? this.v(t) : p;
    }
    /**
     * Consumes characters until the given string is found, advancing the scanner
     * up to (but not beyond) that point. If the string is never found, nothing
     * will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    s(n) {
      let t = this.f(), l = this.h.indexOf(n, t);
      return l > 0 ? this.v(l - t) : p;
    }
    /**
     * Returns the given number of characters starting at the current character
     * index, without advancing the scanner and without exceeding the end of the
     * input string.
     */
    m(n = 1) {
      let { d: t, h: l } = this;
      return this.l ? l.slice(this.f(t), this.f(t + n)) : l.slice(t, t + n);
    }
    /**
     * Resets the scanner position to the given character _index_, or to the start
     * of the input string if no index is given.
     *
     * If _index_ is negative, the scanner position will be moved backward by that
     * many characters, stopping if the beginning of the string is reached.
     */
    n(n = 0) {
      this.d = n >= 0 ? Math.min(this.k, n) : Math.max(0, this.d + n);
    }
  }, k = /["&<]/, N = /['&<]/, Te = /\r\n|[\n\r\t]/g, ke = /<|&|]]>/, Ne = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }));
  function J(n) {
    let t = n.codePointAt(0);
    return t >= 97 && t <= 122 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || t === 45 || t === 46 || t === 183 || t >= 768 && t <= 879 || t === 8255 || t === 8256 || q(n, t);
  }
  function q(n, t = n.codePointAt(0)) {
    return t >= 97 && t <= 122 || t >= 65 && t <= 90 || t === 58 || t === 95 || t >= 192 && t <= 214 || t >= 216 && t <= 246 || t >= 248 && t <= 767 || t >= 880 && t <= 893 || t >= 895 && t <= 8191 || t === 8204 || t === 8205 || t >= 8304 && t <= 8591 || t >= 11264 && t <= 12271 || t >= 12289 && t <= 55295 || t >= 63744 && t <= 64975 || t >= 65008 && t <= 65533 || t >= 65536 && t <= 983039;
  }
  function Ie(n) {
    return n === "#" || J(n);
  }
  function Se(n) {
    let t = n.codePointAt(0);
    return t === 32 || t === 9 || t === 10 || t === 13;
  }
  function z(n) {
    return n >= 32 && n <= 55295 || n === 10 || n === 9 || n === 13 || n >= 57344 && n <= 65533 || n >= 65536 && n <= 1114111;
  }
  var w = class re {
    constructor() {
      this.parent = null, this.start = -1, this.end = -1;
    }
    /**
     * Document that contains this node, or `null` if this node is not associated
     * with a document.
     */
    get document() {
      var t, l;
      return (l = (t = this.parent) == null ? void 0 : t.document) != null ? l : null;
    }
    /**
     * Whether this node is the root node of the document (also known as the
     * document element).
     */
    get isRootNode() {
      return this.parent !== null && this.parent === this.document && this.type === re.TYPE_ELEMENT;
    }
    /**
     * Whether whitespace should be preserved in the content of this element and
     * its children.
     *
     * This is influenced by the value of the special `xml:space` attribute, and
     * will be `true` for any node whose `xml:space` attribute is set to
     * "preserve". If a node has no such attribute, it will inherit the value of
     * the nearest ancestor that does (if any).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-white-space
     */
    get preserveWhitespace() {
      var t;
      return !!((t = this.parent) != null && t.preserveWhitespace);
    }
    /**
     * Type of this node.
     *
     * The value of this property is a string that matches one of the static
     * `TYPE_*` properties on the `XmlNode` class (e.g. `TYPE_ELEMENT`,
     * `TYPE_TEXT`, etc.).
     *
     * The `XmlNode` class itself is a base class and doesn't have its own type
     * name.
     */
    get type() {
      return "";
    }
    /**
     * Returns a JSON-serializable object representing this node, minus properties
     * that could result in circular references.
     */
    toJSON() {
      let t = {
        type: this.type
      };
      return this.isRootNode && (t.isRootNode = !0), this.preserveWhitespace && (t.preserveWhitespace = !0), this.start !== -1 && (t.start = this.start, t.end = this.end), t;
    }
  };
  w.TYPE_CDATA = "cdata", w.TYPE_COMMENT = "comment", w.TYPE_DOCUMENT = "document", w.TYPE_DOCUMENT_TYPE = "doctype", w.TYPE_ELEMENT = "element", w.TYPE_PROCESSING_INSTRUCTION = "pi", w.TYPE_TEXT = "text", w.TYPE_XML_DECLARATION = "xmldecl";
  var m = w, C = class extends m {
    constructor(n = "") {
      super(), this.text = n;
    }
    get type() {
      return m.TYPE_TEXT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        text: this.text
      });
    }
  }, F = class extends C {
    get type() {
      return m.TYPE_CDATA;
    }
  }, R = class extends m {
    constructor(n = "") {
      super(), this.content = n;
    }
    get type() {
      return m.TYPE_COMMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        content: this.content
      });
    }
  }, V = class extends m {
    constructor(n, t, l) {
      super(), this.version = n, this.encoding = t ?? null, this.standalone = l ?? null;
    }
    get type() {
      return m.TYPE_XML_DECLARATION;
    }
    toJSON() {
      let n = m.prototype.toJSON.call(this);
      n.version = this.version;
      for (let t of ["encoding", "standalone"])
        this[t] !== null && (n[t] = this[t]);
      return n;
    }
  }, _ = class le extends m {
    constructor(t, l = /* @__PURE__ */ Object.create(null), u = []) {
      super(), this.name = t, this.attributes = l, this.children = u;
    }
    /**
     * Whether this element is empty (meaning it has no children).
     */
    get isEmpty() {
      return this.children.length === 0;
    }
    get preserveWhitespace() {
      let t = this;
      for (; t instanceof le; ) {
        if ("xml:space" in t.attributes)
          return t.attributes["xml:space"] === "preserve";
        t = t.parent;
      }
      return !1;
    }
    /**
     * Text content of this element and all its descendants.
     */
    get text() {
      return this.children.map((t) => "text" in t ? t.text : "").join("");
    }
    get type() {
      return m.TYPE_ELEMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        name: this.name,
        attributes: this.attributes,
        children: this.children.map((t) => t.toJSON())
      });
    }
  }, G = class extends m {
    constructor(n = []) {
      super(), this.children = n;
    }
    get document() {
      return this;
    }
    /**
     * Root element of this document, or `null` if this document is empty.
     */
    get root() {
      for (let n of this.children)
        if (n instanceof _)
          return n;
      return null;
    }
    /**
     * Text content of this document and all its descendants.
     */
    get text() {
      return this.children.map((n) => "text" in n ? n.text : "").join("");
    }
    get type() {
      return m.TYPE_DOCUMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        children: this.children.map((n) => n.toJSON())
      });
    }
  }, H = class extends m {
    constructor(n, t, l, u) {
      super(), this.name = n, this.publicId = t ?? null, this.systemId = l ?? null, this.internalSubset = u ?? null;
    }
    get type() {
      return m.TYPE_DOCUMENT_TYPE;
    }
    toJSON() {
      let n = m.prototype.toJSON.call(this);
      n.name = this.name;
      for (let t of ["publicId", "systemId", "internalSubset"])
        this[t] !== null && (n[t] = this[t]);
      return n;
    }
  }, K = class extends Error {
    constructor(n, t, l) {
      let u = 1, f = "", d = 1;
      for (let j = 0; j < t; ++j) {
        let Z = l[j];
        Z === `
` ? (u = 1, f = "", d += 1) : (u += 1, f += Z);
      }
      let b = l.indexOf(`
`, t);
      f += b === -1 ? l.slice(t) : l.slice(t, b);
      let v = 0;
      f.length > 50 && (u < 40 ? f = f.slice(0, 50) : (v = u - 20, f = f.slice(v, u + 30))), super(
        `${n} (line ${d}, column ${u})
  ${f}
` + " ".repeat(u - v + 1) + `^
`
      ), this.column = u, this.excerpt = f, this.line = d, this.name = "XmlError", this.pos = t;
    }
  }, D = class extends m {
    constructor(n, t = "") {
      super(), this.name = n, this.content = t;
    }
    get type() {
      return m.TYPE_PROCESSING_INSTRUCTION;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        name: this.name,
        content: this.content
      });
    }
  }, Q = "", Ce = class {
    /**
     * @param xml XML string to parse.
     * @param options Parser options.
     */
    constructor(n, t = {}) {
      let l = this.document = new G();
      this.j = l, this.g = t, this.c = new T(n), this.g.includeOffsets && (l.start = 0, l.end = n.length), this.parse();
    }
    /**
     * Adds the given `XmlNode` as a child of `this.currentNode`.
     */
    i(n, t) {
      return n.parent = this.j, this.g.includeOffsets && (n.start = this.c.f(t), n.end = this.c.f()), this.j.children.push(n), !0;
    }
    /**
     * Adds the given _text_ to the document, either by appending it to a
     * preceding `XmlText` node (if possible) or by creating a new `XmlText` node.
     *
     * When _normalize_ is `true` (the default), line breaks in _text_ are
     * normalized per section 2.11 of the XML spec. This must be `false` for text
     * that comes from a character or entity reference, since references aren't
     * subject to line break normalization.
     */
    y(n, t, l = !0) {
      let { children: u } = this.j, { length: f } = u;
      if (l && (n = I(n)), f > 0) {
        let d = u[f - 1];
        if (d?.type === m.TYPE_TEXT) {
          let b = d;
          return b.text += n, this.g.includeOffsets && (b.end = this.c.f()), !0;
        }
      }
      return this.i(new C(n), t);
    }
    /**
     * Consumes element attributes.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-starttags
     */
    H() {
      let n = /* @__PURE__ */ Object.create(null);
      for (; this.e(); ) {
        let t = this.q();
        if (!t)
          break;
        let l = this.t() && this.I();
        if (l === !1)
          throw this.a("Attribute value expected");
        if (t in n)
          throw this.a(`Duplicate attribute: ${t}`);
        if (t === "xml:space" && l !== "default" && l !== "preserve")
          throw this.a('Value of the `xml:space` attribute must be "default" or "preserve"');
        n[t] = l;
      }
      if (this.g.sortAttributes) {
        let t = Object.keys(n).sort(), l = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < t.length; ++u) {
          let f = t[u];
          l[f] = n[f];
        }
        n = l;
      }
      return n;
    }
    /**
     * Consumes an `AttValue` (attribute value) if possible.
     *
     * @returns
     *   Contents of the `AttValue` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that an `AttValue` was consumed but
     *   was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-AttValue
     */
    I() {
      let { c: n } = this, t = n.m();
      if (t !== '"' && t !== "'")
        return !1;
      n.p();
      let l, u = !1, f = Q, d = t === '"' ? k : N;
      e: for (; !n.B; )
        switch (l = n.x(d), l && (this.o(l), f += l.replace(Te, " ")), n.m()) {
          case t:
            u = !0;
            break e;
          case "&":
            f += this.C();
            continue;
          case "<":
            throw this.a("Unescaped `<` is not allowed in an attribute value");
          default:
            break e;
        }
      if (!u)
        throw this.a("Unclosed attribute");
      return n.p(), f;
    }
    /**
     * Consumes a CDATA section if possible.
     *
     * @returns Whether a CDATA section was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-cdata-sect
     */
    J() {
      let { c: n } = this, t = n.d;
      if (!n.b("<![CDATA["))
        return !1;
      let l = n.s("]]>");
      if (this.o(l), !n.b("]]>"))
        throw this.a("Unclosed CDATA section");
      return this.g.preserveCdata ? this.i(new F(I(l)), t) : this.y(l, t);
    }
    /**
     * Consumes character data if possible.
     *
     * @returns Whether character data was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dt-chardata
     */
    K() {
      let { c: n } = this, t = n.d, l = n.x(ke);
      if (!l)
        return !1;
      if (this.o(l), n.m(3) === "]]>")
        throw this.a("Element content may not contain the CDATA section close delimiter `]]>`");
      return this.y(l, t);
    }
    /**
     * Consumes a comment if possible.
     *
     * @returns Whether a comment was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Comment
     */
    D() {
      let { c: n } = this, t = n.d;
      if (!n.b("<!--"))
        return !1;
      let l = n.s("--");
      if (this.o(l), !n.b("-->"))
        throw n.m(2) === "--" ? this.a("The string `--` isn't allowed inside a comment") : this.a("Unclosed comment");
      return this.g.preserveComments ? this.i(new R(I(l)), t) : !0;
    }
    /**
     * Consumes a reference in a content context if possible.
     *
     * This differs from `consumeReference()` in that a consumed reference will be
     * added to the document as a text node instead of returned.
     *
     * @returns Whether a reference was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#entproc
     */
    L() {
      let n = this.c.d, t = this.C();
      return t ? this.y(t, n, !1) : !1;
    }
    /**
     * Consumes a doctype declaration if possible.
     *
     * This is a loose implementation since doctype declarations are currently
     * discarded without further parsing.
     *
     * @returns Whether a doctype declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dtd
     */
    M() {
      let { c: n } = this, t = n.d;
      if (!n.b("<!DOCTYPE"))
        return !1;
      let l = this.e() && this.q();
      if (!l)
        throw this.a("Expected a name");
      let u, f;
      if (this.e()) {
        if (n.b("PUBLIC")) {
          if (u = this.e() && this.N(), u === !1)
            throw this.a("Expected a public identifier");
          this.e();
        }
        if (u !== void 0 || n.b("SYSTEM")) {
          if (this.e(), f = this.r(), f === !1)
            throw this.a("Expected a system identifier");
          this.e();
        }
      }
      let d;
      if (n.b("[")) {
        if (d = n.x(/\][\x20\t\r\n]*>/), !n.b("]"))
          throw this.a("Unclosed internal subset");
        this.e();
      }
      if (!n.b(">"))
        throw this.a("Unclosed doctype declaration");
      return this.g.preserveDocumentType ? this.i(new H(l, u, f, d), t) : !0;
    }
    /**
     * Consumes an element if possible.
     *
     * @returns Whether an element was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-element
     */
    E() {
      let { c: n } = this, t = n.d;
      if (!n.b("<"))
        return !1;
      let l = this.q();
      if (!l)
        return n.n(t), !1;
      let u = this.H(), f = !!n.b("/>"), d = new _(l, u);
      if (d.parent = this.j, !f) {
        if (!n.b(">"))
          throw this.a(`Unclosed start tag for element \`${l}\``);
        this.j = d;
        do
          this.K();
        while (this.E() || this.L() || this.J() || this.F() || this.D());
        let b = n.d, v;
        if (!n.b("</") || !(v = this.q()) || v !== l)
          throw n.n(b), this.a(`Missing end tag for element ${l}`);
        if (this.e(), !n.b(">"))
          throw this.a(`Unclosed end tag for element ${l}`);
        this.j = d.parent;
      }
      return this.i(d, t);
    }
    /**
     * Consumes an `Eq` production if possible.
     *
     * @returns Whether an `Eq` production was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Eq
     */
    t() {
      return this.e(), this.c.b("=") ? (this.e(), !0) : !1;
    }
    /**
     * Consumes `Misc` content if possible.
     *
     * @returns Whether anything was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Misc
     */
    z() {
      return this.D() || this.F() || this.e();
    }
    /**
     * Consumes one or more `Name` characters if possible.
     *
     * @returns `Name` characters, or an empty string if none were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Name
     */
    q() {
      return q(this.c.m()) ? this.c.w(J) : Q;
    }
    /**
     * Consumes a processing instruction if possible.
     *
     * @returns Whether a processing instruction was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-pi
     */
    F() {
      let { c: n } = this, t = n.d;
      if (!n.b("<?"))
        return !1;
      let l = this.q();
      if (l) {
        if (l.toLowerCase() === "xml")
          throw n.n(t), this.a("XML declaration isn't allowed here");
      } else
        throw this.a("Invalid processing instruction");
      if (!this.e()) {
        if (n.b("?>"))
          return this.i(new D(l), t);
        throw this.a("Whitespace is required after a processing instruction name");
      }
      let u = n.s("?>");
      if (this.o(u), !n.b("?>"))
        throw this.a("Unterminated processing instruction");
      return this.i(new D(l, I(u)), t);
    }
    /**
     * Consumes a prolog if possible.
     *
     * @returns Whether a prolog was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-prolog-dtd
     */
    O() {
      let { c: n } = this, t = n.d;
      for (this.P(); this.z(); )
        ;
      if (this.M())
        for (; this.z(); )
          ;
      return t < n.d;
    }
    /**
     * Consumes a public identifier literal if possible.
     *
     * @returns
     *   Value of the public identifier literal minus quotes, or `false` if
     *   nothing was consumed. An empty string indicates that a public id literal
     *   was consumed but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-PubidLiteral
     */
    N() {
      let n = this.c.d, t = this.r();
      if (t !== !1 && !/^[-\x20\r\na-zA-Z0-9'()+,./:=?;!*#@$_%]*$/.test(t))
        throw this.c.n(n), this.a("Invalid character in public identifier");
      return t;
    }
    /**
     * Consumes a reference if possible.
     *
     * This differs from `consumeContentReference()` in that a consumed reference
     * will be returned rather than added to the document.
     *
     * @returns
     *   Parsed reference value, or `false` if nothing was consumed (to
     *   distinguish from a reference that resolves to an empty string).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Reference
     */
    C() {
      let { c: n } = this;
      if (!n.b("&"))
        return !1;
      let t = n.w(Ie);
      if (n.G() !== ";")
        throw this.a("Unterminated reference (a reference must end with `;`)");
      let l;
      if (t[0] === "#") {
        let u = t[1] === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
        if (isNaN(u) || !/^#(?:x[0-9A-Fa-f]+|[0-9]+)$/.test(t))
          throw this.a("Invalid character reference");
        if (!z(u))
          throw this.a("Character reference resolves to an invalid character");
        l = String.fromCodePoint(u);
      } else if (l = Ne[t], l === void 0) {
        let {
          ignoreUndefinedEntities: u,
          resolveUndefinedEntity: f
        } = this.g, d = `&${t};`;
        if (f) {
          let b = f(d);
          if (b != null) {
            let v = typeof b;
            if (v !== "string")
              throw new TypeError(`\`resolveUndefinedEntity()\` must return a string, \`null\`, or \`undefined\`, but returned a value of type ${v}`);
            return b;
          }
        }
        if (u)
          return d;
        throw n.n(-d.length), this.a(`Named entity isn't defined: ${d}`);
      }
      return l;
    }
    /**
     * Consumes a `SystemLiteral` if possible.
     *
     * A `SystemLiteral` is similar to an attribute value, but allows the
     * characters `<` and `&` and doesn't replace references.
     *
     * @returns
     *   Value of the `SystemLiteral` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that a `SystemLiteral` was consumed
     *   but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-SystemLiteral
     */
    r() {
      let { c: n } = this, t = n.b('"') || n.b("'");
      if (!t)
        return !1;
      let l = n.s(t);
      if (this.o(l), !n.b(t))
        throw this.a("Missing end quote");
      return l;
    }
    /**
     * Consumes one or more whitespace characters if possible.
     *
     * @returns Whether any whitespace characters were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#white
     */
    e() {
      return !!this.c.w(Se);
    }
    /**
     * Consumes an XML declaration if possible.
     *
     * @returns Whether an XML declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-XMLDecl
     */
    P() {
      let { c: n } = this, t = n.d;
      if (!n.b("<?xml"))
        return !1;
      if (!this.e())
        throw this.a("Invalid XML declaration");
      let l = !!n.b("version") && this.t() && this.r();
      if (l === !1)
        throw this.a("XML version is missing or invalid");
      if (!/^1\.[0-9]+$/.test(l))
        throw this.a("Invalid character in version number");
      let u, f;
      if (this.e()) {
        if (u = !!n.b("encoding") && this.t() && this.r(), u) {
          if (!/^[A-Za-z][\w.-]*$/.test(u))
            throw this.a("Invalid character in encoding name");
          this.e();
        }
        if (f = !!n.b("standalone") && this.t() && this.r(), f) {
          if (f !== "yes" && f !== "no")
            throw this.a('Only "yes" and "no" are permitted as values of `standalone`');
          this.e();
        }
      }
      if (!n.b("?>"))
        throw this.a("Invalid or unclosed XML declaration");
      return this.g.preserveXmlDeclaration ? this.i(new V(
        l,
        u || void 0,
        f || void 0
      ), t) : !0;
    }
    /**
     * Returns an `XmlError` for the current scanner position.
     */
    a(n) {
      let { c: t } = this;
      return new K(n, t.d, t.h);
    }
    /**
     * Parses the XML input.
     */
    parse() {
      if (this.c.b("\uFEFF"), this.O(), !this.E())
        throw this.a("Root element is missing or invalid");
      for (; this.z(); )
        ;
      if (!this.c.B)
        throw this.a("Extra content at the end of the document");
    }
    /**
     * Throws an invalid character error if any character in the given _string_
     * isn't a valid XML character.
     */
    o(n) {
      let { length: t } = n;
      for (let l = 0; l < t; ++l) {
        let u = n.codePointAt(l);
        if (!z(u))
          throw this.c.n(-([...n].length - l)), this.a("Invalid character");
        u > 65535 && (l += 1);
      }
    }
  };
  function I(n) {
    let t = 0;
    for (; (t = n.indexOf("\r", t)) !== -1; )
      n = n[t + 1] === `
` ? n.slice(0, t) + n.slice(t + 1) : n.slice(0, t) + `
` + n.slice(t + 1);
    return n;
  }
  function _e(n, t) {
    return new Ce(n, t).document;
  }
  return X;
}
var je = De();
function Xe(e) {
  const i = String(e), s = [];
  return { toOffset: o, toPoint: a };
  function a(r) {
    if (typeof r == "number" && r > -1 && r <= i.length) {
      let c = 0;
      for (; ; ) {
        let h = s[c];
        if (h === void 0) {
          const p = te(i, s[c - 1]);
          h = p === -1 ? i.length + 1 : p + 1, s[c] = h;
        }
        if (h > r)
          return {
            line: c + 1,
            column: r - (c > 0 ? s[c - 1] : 0) + 1,
            offset: r
          };
        c++;
      }
    }
  }
  function o(r) {
    if (r && typeof r.line == "number" && typeof r.column == "number" && !Number.isNaN(r.line) && !Number.isNaN(r.column)) {
      for (; s.length < r.line; ) {
        const h = s[s.length - 1], p = te(i, h), g = p === -1 ? i.length + 1 : p + 1;
        if (h === g) break;
        s.push(g);
      }
      const c = (r.line > 1 ? s[r.line - 2] : 0) + r.column - 1;
      if (c < s[r.line - 1]) return c;
    }
  }
}
function te(e, i) {
  const s = e.indexOf("\r", i), a = e.indexOf(`
`, i);
  return a === -1 ? s : s === -1 || s + 1 === a ? a : s < a ? s : a;
}
function Oe(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? ne(e.position) : "start" in e || "end" in e ? ne(e) : "line" in e || "column" in e ? A(e) : "";
}
function A(e) {
  return ie(e && e.line) + ":" + ie(e && e.column);
}
function ne(e) {
  return A(e && e.start) + "-" + A(e && e.end);
}
function ie(e) {
  return e && typeof e == "number" ? e : 1;
}
class y extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(i, s, a) {
    super(), typeof s == "string" && (a = s, s = void 0);
    let o = "", r = {}, c = !1;
    if (s && ("line" in s && "column" in s ? r = { place: s } : "start" in s && "end" in s ? r = { place: s } : "type" in s ? r = {
      ancestors: [s],
      place: s.position
    } : r = { ...s }), typeof i == "string" ? o = i : !r.cause && i && (c = !0, o = i.message, r.cause = i), !r.ruleId && !r.source && typeof a == "string") {
      const p = a.indexOf(":");
      p === -1 ? r.ruleId = a : (r.source = a.slice(0, p), r.ruleId = a.slice(p + 1));
    }
    if (!r.place && r.ancestors && r.ancestors) {
      const p = r.ancestors[r.ancestors.length - 1];
      p && (r.place = p.position);
    }
    const h = r.place && "start" in r.place ? r.place.start : r.place;
    this.ancestors = r.ancestors || void 0, this.cause = r.cause || void 0, this.column = h ? h.column : void 0, this.fatal = void 0, this.file = "", this.message = o, this.line = h ? h.line : void 0, this.name = Oe(r.place) || "1:1", this.place = r.place || void 0, this.reason = this.message, this.ruleId = r.ruleId || void 0, this.source = r.source || void 0, this.stack = c && r.cause && typeof r.cause.stack == "string" ? r.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
y.prototype.file = "";
y.prototype.name = "";
y.prototype.reason = "";
y.prototype.message = "";
y.prototype.stack = "";
y.prototype.column = void 0;
y.prototype.line = void 0;
y.prototype.ancestors = void 0;
y.prototype.cause = void 0;
y.prototype.fatal = void 0;
y.prototype.place = void 0;
y.prototype.ruleId = void 0;
y.prototype.source = void 0;
function Ae(e) {
  const i = Xe(e);
  let s;
  try {
    s = je.parseXml(String(e), {
      // Positional offsets.
      includeOffsets: !0,
      // `<![CDATA[>&<]]>`
      preserveCdata: !0,
      // `<!--a-->`
      preserveComments: !0,
      // `<!DOCTYPE b>` (a specific declaration)
      preserveDocumentType: !0,
      // `<?xml?>` (a specific instruction)
      preserveXmlDeclaration: !0
    });
  } catch (r) {
    const c = (
      /** @type {XmlError} */
      r
    ), h = i.toPoint(c.pos), p = new y(
      "Could not parse XML with `@rgrove/parse-xml`",
      {
        cause: c,
        place: h,
        ruleId: "error",
        source: "xast-util-from-xml"
      }
    );
    throw p.fatal = !0, p.url = "https://github.com/syntax-tree/xast-util-from-xml#throws", p;
  }
  const a = { location: i }, o = Pe(s, a);
  return oe(s, o, a), o;
}
function Le(e) {
  return { type: "cdata", value: e.text };
}
function Me(e) {
  return { type: "comment", value: e.content };
}
function Pe(e, i) {
  return { type: "root", children: ae(e.children, i) };
}
function We(e) {
  return {
    type: "doctype",
    name: e.name,
    public: e.publicId || void 0,
    system: e.systemId || void 0
  };
}
function Ye(e, i) {
  const s = ae(e.children, i);
  return {
    type: "element",
    name: e.name,
    attributes: { ...e.attributes },
    // @ts-expect-error: assume content matches.
    children: s
  };
}
function Ue(e) {
  return { type: "instruction", name: e.name, value: e.content };
}
function Be(e) {
  return { type: "text", value: e.text };
}
function Je(e) {
  const i = [];
  return e.version && i.push('version="' + e.version + '"'), e.encoding && i.push('encoding="' + e.encoding + '"'), e.standalone && i.push('standalone="' + e.standalone + '"'), { type: "instruction", name: "xml", value: i.join(" ") };
}
function ae(e, i) {
  const s = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a];
    let r;
    o.type === "cdata" ? r = Le(
      /** @type {XmlCdata} */
      o
    ) : o.type === "comment" ? r = Me(
      /** @type {XmlComment} */
      o
    ) : o.type === "doctype" ? r = We(
      /** @type {XmlDocumentType} */
      o
    ) : o.type === "element" ? r = Ye(
      /** @type {XmlElement} */
      o,
      i
    ) : o.type === "pi" ? r = Ue(
      /** @type {XmlProcessingInstruction} */
      o
    ) : o.type === "text" ? r = Be(
      /** @type {XmlText} */
      o
    ) : o.type === "xmldecl" && (r = Je(
      /** @type {XmlDeclaration} */
      o
    )), r && (oe(o, r, i), s.push(r));
  }
  return s;
}
function oe(e, i, s) {
  const a = (
    // Doesn’t practically happen as far as I found, but `-1` is used in the
    // code, so let’s keep it in.
    /* c8 ignore next */
    e.start === -1 ? void 0 : s.location.toPoint(e.start)
  ), o = (
    // Same as above
    /* c8 ignore next */
    e.end === -1 ? void 0 : s.location.toPoint(e.end)
  );
  a && o && (i.position = { start: a, end: o });
}
const ce = [
  "abstract",
  "acknowledgement",
  "affiliation",
  "appendix",
  "article",
  "author",
  "backmatter",
  "biography",
  "book",
  "chapter",
  "colophon",
  "contributor",
  "contributors",
  "copyright",
  "credit",
  "dedication",
  "docinfo",
  "editor",
  "feedback",
  "frontmatter",
  "google",
  "html",
  "index",
  "macros",
  "mathbook",
  "preface",
  "pretext",
  "references",
  "search",
  "shortlicense",
  "solutions",
  "subsection",
  "titlepage",
  "website"
], ue = [
  "assemblage",
  "chapter",
  "conclusion",
  "introduction",
  "objectives",
  "outcomes",
  "paragraphs",
  "part",
  "postlude",
  "prelude",
  "reading-questions",
  "sbsgroup",
  "section",
  "stack",
  "subsection",
  "subsubsection",
  "task",
  "technology",
  "worksheet"
], he = [
  "activity",
  "algorithm",
  "answer",
  "axiom",
  "biblio",
  "blockquote",
  "case",
  "choice",
  "choices",
  "claim",
  "conjecture",
  "console",
  "corollary",
  "definition",
  "demonstration",
  "description",
  "example",
  "exercise",
  "exploration",
  "fact",
  "hint",
  "image",
  "images",
  "insight",
  "interactive",
  "investigation",
  "lemma",
  "list",
  "listing",
  "note",
  "openconjecture",
  "openproblem",
  "openquestion",
  "page",
  "poem",
  "principle",
  "problem",
  "program",
  "project",
  "proof",
  "proposition",
  "question",
  "remark",
  "shortdescription",
  "solution",
  "stanza",
  "statement",
  "subtask",
  "table",
  "tabular",
  "theorem",
  "video",
  "warning",
  "webwork"
], P = [
  "address",
  "attribution",
  "caption",
  "cline",
  "date",
  "department",
  "description",
  "edition",
  "entity",
  "holder",
  "idx",
  "institution",
  "journal",
  "line",
  "location",
  "minilicense",
  "mrow",
  "personname",
  "pg-macros",
  "pubtitle",
  "subtitle",
  "support",
  "title",
  "usage",
  "volume",
  "year",
  "xi:include",
  // Short scalar values — bibliography/metadata fields, publication settings, and
  // inline markup-documentation tags. Each belongs on one line with its tags;
  // otherwise appendBlock pushes the value onto a line of its own.
  "DOI",
  "ISBN",
  "ISSN",
  "archive",
  "attr",
  "de-number",
  "document-id",
  "dropping-particle",
  "email",
  "genre",
  "genus",
  "geometry",
  "initialism",
  "issue",
  "kbd",
  "literal",
  "macro-file",
  "mag",
  "non-dropping-particle",
  "number-of-pages",
  "page-first",
  "pages",
  "rename",
  "scaledeg",
  "series",
  "species",
  "static-ordering",
  "suffix",
  "tag",
  "tage",
  "watermark",
  "xhtml:button"
], qe = ["ol", "ul", "dl"], ze = ["me", "men", "md", "mdn"], fe = [
  "ul",
  "ol",
  "li",
  "p",
  "task",
  "figure",
  "sidebyside",
  "notation",
  "row"
], pe = [
  "latex-image-preamble",
  "latex-image",
  "latex-preamble",
  "slate",
  "sage",
  "sageplot",
  "asymptote",
  "macros",
  "prefigure",
  "program",
  "preamble",
  "postamble",
  "input",
  "output",
  "prompt",
  "pre",
  "pg-code",
  "script",
  "tikzpicture",
  "tikz",
  "code",
  "c",
  "cd",
  // Code-carrying elements whose text is executed, rendered, or matched as-is.
  // Re-indenting them changes what they mean, so they must round-trip exactly.
  "strcmp",
  // literal/regex a fill-in answer is compared against
  "jscmp",
  // JavaScript comparison expression
  "mermaid",
  // Mermaid source; relative indentation is significant
  "stdin",
  // data piped to a <program>
  "asymptote-preamble",
  "setupScript",
  // JavaScript run before an <interactive> renders
  "postRenderScript",
  // JavaScript run after an <interactive> renders
  "source",
  // <interactive> source text
  "pf",
  // inline verbatim, like <c> — see isBlockChild in format.ts
  "config-json",
  // JSON configuration for an <interactive>
  "program-preamble",
  // fixed code before a Parsons <program> solution
  "program-postamble"
  // fixed code after a Parsons <program> solution
], Fe = [
  ...ce,
  ...ue,
  ...he,
  ...fe,
  "xi:include"
], Re = [
  ...ce,
  ...ue,
  ...he,
  ...fe,
  ...ze,
  ...qe
], L = ["p", "li", "fn"], de = [
  "title",
  "shorttitle",
  "subtitle",
  "caption",
  "attribution",
  "personname",
  "location",
  "date",
  "edition",
  "entity",
  "support",
  "name",
  "given",
  "family",
  "usage",
  "volume",
  "number",
  "collection-title",
  "page",
  "year",
  "publisher",
  "publisher-place",
  "URL",
  "issued",
  "description",
  "shortdescription",
  "q",
  "premise",
  "response",
  "li",
  "cell",
  // Prose-like metadata: single line when it fits, reflowed when it does not.
  "blurb",
  "plaintitle"
];
function Ve(e) {
  const i = e?.breakLines ?? "some", s = e?.tabSize ?? 2, a = e?.insertSpaces ?? !0, o = e?.breakSentences ?? !1, r = e?.breakLongAttributes ?? !1, c = e?.printWidth ?? 80;
  return { ind: a ? " ".repeat(s) : "	", blankLines: i, breakSentences: o, breakLongAttributes: r, printWidth: c };
}
function me(e, i) {
  const s = Ve(i), a = [];
  e.children.length === 1 && e.children[0].type === "element" && e.children[0].name === "tmp-root" && (e = { ...e, children: e.children[0].children });
  const o = e.children.filter(
    (c) => !(c.type === "text" && c.value.trim() === "")
  );
  be(o, a, 0, s, et);
  const r = Ze(a, s);
  for (; r.length > 0 && r[r.length - 1] === ""; ) r.pop();
  return r.join(`
`);
}
const nt = function(e) {
  this.compiler = (i) => me(i, e);
};
function it(e, i) {
  let s, a = null;
  if (e.startsWith("<?xml")) {
    const r = e.indexOf("?>");
    if (r !== -1) {
      const c = r + 2;
      a = e.slice(0, c), e = e.slice(c);
    }
  }
  e = `<tmp-root>${e}</tmp-root>`;
  try {
    s = Ae(e);
  } catch {
    return console.warn("Input is not well-formed XML; returning original text."), e = e.replace(/<tmp-root>(.*?)<\/tmp-root>/s, "$1"), a && (e = a + `

` + e), e;
  }
  let o = me(s, i);
  return a && (o = a + `

` + o), o;
}
function se(e, i, s, a) {
  switch (e.type) {
    case "instruction":
      i.push(`<?${e.name}${e.value ? " " + e.value : ""}?>`);
      break;
    case "doctype":
      i.push(`<!DOCTYPE ${e.name}>`);
      break;
    case "comment":
      i.push(`${a.ind.repeat(s)}<!--${e.value}-->`);
      break;
    case "cdata":
      i.push(`${a.ind.repeat(s)}<![CDATA[${e.value}]]>`);
      break;
    case "text": {
      const o = e.value.trim();
      o && i.push(`${a.ind.repeat(s)}${S(o)}`);
      break;
    }
    case "element":
      ge(e, i, s, a);
      break;
  }
}
function ge(e, i, s, a) {
  const o = e.name;
  pe.includes(o) ? Ge(e, i, s, a) : de.includes(o) ? Ke(e, i, s, a) : P.includes(o) ? He(e, i, s, a) : L.includes(o) && !Ee(e) ? Qe(e, i, s, a) : L.includes(o) ? ye(e, i, s, a) : ve(e, i, s, a);
}
function Ge(e, i, s, a) {
  if (e.children.some((h) => h.type === "element")) {
    ve(e, i, s, a);
    return;
  }
  const o = a.ind.repeat(s);
  if (x(e)) {
    i.push(`${o}${E(e)}`);
    return;
  }
  const r = e.children.map((h) => h.type === "text" ? S(h.value) : h.type === "cdata" ? `<![CDATA[${h.value}]]>` : h.type === "comment" ? `<!--${h.value}-->` : "").join("");
  if (/\n[ \t]*$/.test(r)) {
    const h = r.replace(/\n[ \t]*$/, `
`);
    i.push(`${o}${$(e)}${h}${o}</${e.name}>`);
  } else
    i.push(`${o}${$(e)}${r}</${e.name}>`);
}
function He(e, i, s, a) {
  const o = a.ind.repeat(s);
  if (x(e)) {
    i.push(`${o}${E(e)}`);
    return;
  }
  const r = W(e.children);
  i.push(`${o}${$(e)}${r}</${e.name}>`);
}
function Ke(e, i, s, a) {
  const o = a.ind.repeat(s);
  if (x(e)) {
    i.push(`${o}${E(e)}`);
    return;
  }
  if (Ee(e)) {
    ye(e, i, s, a);
    return;
  }
  const r = Y(e.children), c = a.ind.repeat(s + 1), h = `${o}${$(e)}${r.join(" ")}</${e.name}>`;
  if (a.printWidth === 0 || h.length <= a.printWidth) {
    i.push(h);
    return;
  }
  i.push(`${o}${$(e)}`);
  for (const p of U(
    r,
    a.printWidth,
    c.length,
    a.breakSentences
  ))
    i.push(`${c}${p}`);
  i.push(`${o}</${e.name}>`);
}
function Qe(e, i, s, a) {
  const o = a.ind.repeat(s), r = a.ind.repeat(s + 1);
  if (x(e)) {
    i.push(`${o}${E(e)}`);
    return;
  }
  i.push(`${o}${$(e)}`);
  const c = Y(e.children);
  for (const h of U(
    c,
    a.printWidth,
    r.length,
    a.breakSentences
  ))
    i.push(`${r}${h}`);
  i.push(`${o}</${e.name}>`);
}
function be(e, i, s, a, o) {
  const r = a.ind.repeat(s);
  let c = 0;
  for (; c < e.length; )
    if (o(e[c])) {
      const h = e[c];
      c++;
      let p = "";
      if (c < e.length && e[c].type === "text") {
        const T = e[c].value, k = /^(\s*)([.,;:!?])/.exec(T);
        if (k) {
          p = k[2];
          const N = T.slice(k[0].length);
          e[c].value = N, N.trim() || c++;
        }
      }
      const g = [];
      ge(h, g, s, a), p && g.length > 0 && (g[g.length - 1] += p), i.push(...g);
    } else {
      const h = [];
      for (; c < e.length && !o(e[c]); )
        h.push(e[c]), c++;
      const p = Y(h);
      if (p.length > 0)
        for (const g of U(
          p,
          a.printWidth,
          r.length,
          a.breakSentences
        ))
          i.push(`${r}${g}`);
    }
}
function ye(e, i, s, a) {
  const o = a.ind.repeat(s);
  if (x(e)) {
    i.push(`${o}${E(e)}`);
    return;
  }
  i.push(`${o}${$(e)}`), be(
    M(e),
    i,
    s + 1,
    a,
    B
  ), i.push(`${o}</${e.name}>`);
}
function ve(e, i, s, a) {
  const o = a.ind.repeat(s);
  if (x(e)) {
    i.push(...O(e, s, a, !0));
    return;
  }
  const r = M(e);
  if (r.length === 1 && r[0].type === "element" && r[0].name === "xi:include") {
    const c = r[0], h = O(e, s, a);
    if (h.length === 1) {
      const p = x(c) ? E(c) : `${$(c)}${W(c.children)}</${c.name}>`;
      i.push(`${h[0]}${p}</${e.name}>`);
      return;
    }
    i.push(...h), se(c, i, s + 1, a), i.push(`${o}</${e.name}>`);
    return;
  }
  i.push(...O(e, s, a));
  for (const c of M(e))
    se(c, i, s + 1, a);
  i.push(`${o}</${e.name}>`);
}
function Ze(e, i) {
  const s = [];
  for (let a = 0; a < e.length; a++) {
    const o = e[a].trim(), r = a < e.length - 1 ? e[a + 1].trim() : null;
    if (s.push(e[a]), a === 0 && /^<\?xml(?:\s|\?>)/.test(o)) {
      s.push("");
      continue;
    }
    if (i.blankLines !== "few")
      if (i.blankLines === "some")
        if (o.startsWith("</") && r !== null && r.startsWith("<")) {
          const c = /^<([^\s>/]+)/.exec(r)?.[1];
          c && Fe.includes(c) && s.push("");
        } else /^<title[\s>]/.test(o) && o.includes("</title>") && s.push("");
      else i.blankLines === "many" && (o.startsWith("</") || o.startsWith("<") && r !== null && r.startsWith("<")) && s.push("");
  }
  return s;
}
function W(e) {
  return e.map((i) => i.type === "text" ? S(i.value) : i.type === "element" ? we(i) : i.type === "comment" ? `<!--${i.value}-->` : i.type === "cdata" ? `<![CDATA[${i.value}]]>` : "").join("");
}
function we(e) {
  return x(e) ? E(e) : `${$(e)}${W(e.children)}</${e.name}>`;
}
function Y(e) {
  const i = [];
  for (const s of e)
    if (s.type === "text") {
      const a = s.value.split(/\s+/).filter((o) => o.length > 0);
      for (let o = 0; o < a.length; o++) {
        const r = S(a[o]);
        o === 0 && i.length > 0 && /^[.,;:!?\-]/.test(r) ? i[i.length - 1] += r : i.push(r);
      }
    } else s.type === "element" ? i.push(we(s)) : s.type === "comment" && i.push(`<!--${s.value}-->`);
  return i;
}
function U(e, i, s, a) {
  if (e.length === 0) return [];
  const o = i === 0 ? 1 / 0 : Math.max(20, i - s), r = [];
  let c = "";
  for (let h = 0; h < e.length; h++) {
    const p = e[h];
    c === "" ? c = p : c.length + 1 + p.length <= o ? c += " " + p : (r.push(c), c = p), a && /[.!?]$/.test(p) && h < e.length - 1 && (r.push(c), c = "");
  }
  return c && r.push(c), r;
}
function $(e) {
  const i = $e(e);
  return i ? `<${e.name} ${i}>` : `<${e.name}>`;
}
function E(e) {
  const i = $e(e);
  return i ? `<${e.name} ${i}/>` : `<${e.name}/>`;
}
function $e(e) {
  return xe(e).join(" ");
}
function xe(e) {
  return Object.entries(e.attributes || {}).map(([i, s]) => s == null ? i : `${i}="${tt(s)}"`);
}
function O(e, i, s, a = !1) {
  const o = s.ind.repeat(i), r = xe(e), c = a ? "/>" : ">";
  if (r.length === 0)
    return [`${o}<${e.name}${c}`];
  const h = `${o}<${e.name} ${r.join(" ")}${c}`;
  if (!s.breakLongAttributes || s.printWidth === 0 || h.length <= s.printWidth)
    return [h];
  const p = `${o}${" ".repeat(e.name.length + 2)}`, g = [`${o}<${e.name} ${r[0]}`];
  for (const T of r.slice(1))
    g.push(`${p}${T}`);
  return g[g.length - 1] += c, g;
}
function x(e) {
  return e.children.every((i) => i.type === "text" && i.value.trim() === "");
}
function M(e) {
  return e.children.filter(
    (i) => !(i.type === "text" && i.value.trim() === "")
  );
}
function B(e) {
  if (e.type !== "element") return !1;
  const i = e.name;
  return i === "c" || i === "pf" || x(e) ? !1 : (Re.includes(i) || pe.includes(i)) && !P.includes(i);
}
function et(e) {
  if (B(e)) return !0;
  if (e.type !== "element") return !1;
  const i = e.name;
  return de.includes(i) || P.includes(i) || L.includes(i);
}
function Ee(e) {
  return e.children.some((i) => B(i));
}
function S(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function tt(e) {
  return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
export {
  Re as blockTags,
  he as docEnvs,
  ue as docSecs,
  ce as docStructure,
  it as formatPretext,
  P as lineEndTags,
  Fe as newlineTags,
  L as parTags,
  nt as pretextFormatPlugin,
  me as serializeXast,
  de as smartParTags,
  pe as verbatimTags
};
